export const IMAGE_ACCEPTED_MIMES = 'image/jpeg,image/png,image/webp';
export const IMAGE_ACCEPT_EXTENSIONS = '.jpg,.jpeg,.png,.webp';
